<template>
  <el-button
    class="btn-test"
    icon="el-icon-lightning"
    :size="size"
    :disabled="disabled"
    :loading="loading"
    @click="onClick">
    {{ label || $t('settings.adConnections.testConnection') }}
  </el-button>
</template>

<script>
export default {
  name: 'BaseTestConnectionButton',
  props: {
    request: {type: Function, required: true},
    validate: {type: Function, default: null},
    successKey: {type: String, default: 'connected'},
    failMessage: {type: String, default: null},
    errorFormatter: {type: Function, default: null},
    successMessage: {type: String, default: null},
    label: {type: String, default: null},
    size: {type: String, default: null},
    disabled: {type: Boolean, default: false},
  },
  data() {
    return {loading: false};
  },
  methods: {
    reset() {
      this.loading = false;
    },
    async onClick() {
      if (this.validate) {
        try {
          await this.validate();
        } catch (e) {
          return;
        }
      }

      this.loading = true;
      try {
        const response = await this.request();
        const result = response && response.data !== undefined ? response.data : response;

        if (result && result[this.successKey]) {
          this.$message.success(this.successMessage || this.$t('settings.adConnections.validationSuccess'));
        } else {
          this.$message.error(this.failMessage || this.$t('settings.genericHttpError'));
        }
        this.$emit('result', result);
      } catch (e) {
        this.$message.error(
          this.errorFormatter ? this.errorFormatter(e) : this.$t('settings.genericHttpError')
        );
        this.$emit('error', e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.btn-test {
  border-radius: 8px;
  color: var(--text-secondary);
  font-weight: 500;

  &:not(.is-disabled):hover {
    color: var(--primary);
    border-color: var(--primary);
  }
}
</style>
